define('views/parts/menu/menu-dropdown',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // views
    'views/parts/menu/menu-dropdown-item',
    //'views/modules/member/group-panel',
    // templates
    'text!templates/parts/menu/menu-dropdown.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMenuDropdownItem,
    //VGroupPanel,
    // templates
    TMenuDropdown
) {

    var VMenuDropdown = Backbone.View.extend({
        template: TMenuDropdown,
        events: {
            "click .dropdown-toggle": "toggle",
            "click #manage-group-button": "onManageGroupClick"
        },
        regions: {
            container: ".dropdown",
            menu: ".dropdown-menu",
            toggle: ".dropdown-toggle",
            label: ".dropdown-label"
        },

        initialize: function(opt) {
            this.options = _.extend({
                showLabel: false,
                labelposition: "top",
                displayManageGroup: true,
            }, opt);

            var toggleEvent = { 'click': this.toggle };
            this.listenTo(opt.treeView, toggleEvent)
                .listenTo(this.collection, toggleEvent);
        },
        render: function() {

            this.removeChildViews({ defer: true });

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones();

            return this;
        },

        addAll: function() {
            var container = document.createDocumentFragment();
            this.collection.each(function(model) {
                container.appendChild(this.addOne(model, false).el);
            }, this);
            this.zone.$menu.append(container);
        },

        addOne: function(model, render) {
            var view = new VMenuDropdownItem({
                context: this.options.context,
                model: model
            });
            this.childViews.push(view);
            view.render();
            if (render !== false) {
                this.zone.$menu.append(view.el);
            }
            return view;
        },

        toggle: function(val) {
            if (!this.zone.$container.hasClass('open') && this.childViews.length === 0) {
                this.addAll();
            }
            this.zone.$container.toggleClass('open', val);

        },

        close: function() {
            this.toggle(false);
        },

        setLabel: function(label) {
            this.options.label = label;
            if (this.zone) {
                this.zone.$label.html(label);
            }
        },

        getLabelById: function(id) {
            return this.collection.get(id).get('label');
        },

        onManageGroupClick: function(e) {
            e.preventDefault();

            var context = this.options.context || this,
                callback = this.options.callback;

            _.callback(context, callback, [e]);

            this.trigger("onManageGroupClick", e);
        },

    });

    return VMenuDropdown;

});

